<script setup lang="ts">
useSeoMeta({
  title: 'Healistic - Digital Prescription Platform for Doctors | Easy, Secure, Efficient',
  ogTitle: 'Healistic - Digital Prescription Platform for Doctors',
  description: 'Healistic is a private digital prescription platform that empowers doctors with an easy-to-use interface for fast and secure medication prescriptions. Deliver medications to patients within hours across the UK, enhance patient satisfaction, and streamline the prescription process.',
  ogDescription: 'Enhance patient care with Healistic, a secure and user-friendly digital prescription platform for doctors.',
});
</script>

<template>
  <main>
    <SectionsHero class="pb-12 sm:pb-20" />
    <SectionsTestimonialsClinicCyan class="pb-8 sm:pb-12.5" />
    <SectionsHowItWorks class="py-16 xs:pb-36 sm:pt-22 sm:pb-[11.5rem]" />
    <SectionsWhyChooseUs class="py-16 xs:pb-36 sm:py-22" />
    <SectionsValues class="py-16 xs:pb-36 sm:py-22" />
    <SectionsGetInTouch class="py-6" />
    <SectionsStartInformation class="py-8 xs:py-12 sm:py-15" />
    <SectionsImacSlider class="py-6" />
    <SectionsMediaCoverage class="mt-16 mb-8 xs:mt-25 xs:mb-11" />
    <SectionsJourney class="pt-8 pb-4 sm:pb-7 sm:pt-11" />
  </main>
</template>
